import hasFeature from 'modules/core/lib/hasFeature'
import { Collection } from 'modules/core/lib/mobx-rest'

import Variable, { ITemplateVariable } from 'modules/documents/store/models/Variable'

import customFieldVariables from './customFieldVariables'
import fieldVariables from './fieldVariables'

class Variables extends Collection<Variable> {
  get cacheKey(): string {
    return 'variables'
  }

  model() {
    return Variable
  }

  async allVariables(): Promise<void> {
    let customFields: ITemplateVariable[] = []
    const fields: ITemplateVariable[] = await fieldVariables.fetch()
    if (hasFeature('dev_template_custom_fields')) {
      customFields = await customFieldVariables.fetch()
    }
    const result = [...fields, ...customFields]

    this.set(result)
  }

  byVariable(variable: string): Variable | null | undefined {
    return this.find({
      variable,
    })
  }

  // Model not coming from database so need to define primary key
  get primaryKey(): string {
    return 'variable'
  }
}

const singleton: Variables = new Variables()

export default singleton
